import { render, staticRenderFns } from "./GestorDocumental.vue?vue&type=template&id=7a3c2a45&scoped=true"
import script from "./GestorDocumental.vue?vue&type=script&lang=js"
export * from "./GestorDocumental.vue?vue&type=script&lang=js"
import style0 from "./GestorDocumental.vue?vue&type=style&index=0&id=7a3c2a45&prod&scoped=true&lang=css"
import style1 from "~/assets/style/toolbar-panels.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3c2a45",
  null
  
)

export default component.exports